import { render, staticRenderFns } from "./Flushs.vue?vue&type=template&id=387153a8&scoped=true"
import script from "./Flushs.vue?vue&type=script&lang=js"
export * from "./Flushs.vue?vue&type=script&lang=js"
import style0 from "./Flushs.vue?vue&type=style&index=0&id=387153a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387153a8",
  null
  
)

export default component.exports